/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_Toast_Account_Needed_DescriptionInputs */

const en_auth_login_toast_account_needed_description = /** @type {(inputs: Auth_Login_Toast_Account_Needed_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign up first and accept the Terms & Conditions to create an account.`)
};

/**
* | output |
* | --- |
* | "Sign up first and accept the Terms & Conditions to create an account." |
*
* @param {Auth_Login_Toast_Account_Needed_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth_login_toast_account_needed_description = /** @type {((inputs?: Auth_Login_Toast_Account_Needed_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_Toast_Account_Needed_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_login_toast_account_needed_description(inputs)
});